import React from 'react';
import { functionTexts } from '../contexts/LangMOB';
import roamingImg from '../assets/images/mobileum/roaming.png';
import riskImg from '../assets/images/mobileum/risk.png';
import networkImg from '../assets/images/mobileum/network.png';
import testingImg from '../assets/images/mobileum/testing.png';
import customerImg from '../assets/images/mobileum/customer.png';
import dataImg from '../assets/images/mobileum/data.png';

function ProductMOBFunction2({ lang = 'ko', isMobile = false }) {
  const containers = [
    { img: roamingImg, alt: 'Roaming', title: functionTexts.roaming.title, desc: functionTexts.roaming.desc },
    { img: riskImg, alt: 'Risk', title: functionTexts.risk.title, desc: functionTexts.risk.desc },
    { img: networkImg, alt: 'Network', title: functionTexts.network.title, desc: functionTexts.network.desc },
    { img: testingImg, alt: 'Testing', title: functionTexts.testing.title, desc: functionTexts.testing.desc },
    { img: customerImg, alt: 'Customer', title: functionTexts.customer.title, desc: functionTexts.customer.desc },
    { img: dataImg, alt: 'Data', title: functionTexts.data.title, desc: functionTexts.data.desc },
  ];

  return (
    <div
      style={{
        width: '100%',
        maxWidth: '100vw',
        background: 'rgba(41, 34, 92, 0.85)',
        // background: '#2C3E50',
        // borderRadius: 12,
        boxShadow: '0 2px 12px rgba(0,0,0,0.10)',
        padding: isMobile ? '20px 16px' : '32px 40px',
        boxSizing: 'border-box',
        overflowX: isMobile ? 'auto' : 'hidden'
      }}
    >
      <span style={{
        fontSize: isMobile ? '1.5rem' : '2rem',
        fontWeight: 700,
        color: '#fff',
        marginBottom: isMobile ? 12 : 24,
        display: 'block',
        lineHeight: 1.3,
        textAlign: 'center',
        width: '100%'
      }}>
        {functionTexts.title[lang]}
      </span>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: isMobile ? '12px' : '20px',
          width: '100%',
        }}
      >
        {/* 첫 번째 줄: 3개 */}
        <div
          style={{
            display: 'flex',
            flexDirection: isMobile ? 'column' : 'row',
            gap: isMobile ? '12px' : '24px',
            width: '100%',
            justifyContent: 'center',
          }}
        >
          {containers.slice(0, 3).map((item, index) => (
            <div
              key={index}
              style={{
                background: '#fff',
                borderRadius: 10,
                boxShadow: '0 1px 6px rgba(0,0,0,0.08)',
                padding: isMobile ? '16px 12px' : '28px 24px',
                minWidth: isMobile ? '100%' : '280px',
                maxWidth: isMobile ? '100%' : '380px',
                flex: isMobile ? '1 1 100%' : '1 1 0',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                textAlign: 'center'
              }}
            >
              <img
                src={item.img}
                alt={item.alt}
                style={{
                  width: isMobile ? '120px' : '180px',
                  height: isMobile ? '120px' : '180px',
                  objectFit: 'contain',
                  marginBottom: '16px'
                }}
              />
              <div style={{
                fontWeight: 700,
                fontSize: isMobile ? '0.85rem' : '1.1rem',
                color: '#09225C',
                marginBottom: '10px',
                lineHeight: 1.3
              }}>
                {item.title[lang]}
              </div>
              <div style={{
                fontWeight: 400,
                fontSize: isMobile ? '0.7rem' : '0.85rem',
                color: '#444',
                lineHeight: 1.5,
                whiteSpace: 'pre-line'
              }}>
                {item.desc[lang]}
              </div>
            </div>
          ))}
        </div>
        {/* 두 번째 줄: 3개 */}
        <div
          style={{
            display: 'flex',
            flexDirection: isMobile ? 'column' : 'row',
            gap: isMobile ? '12px' : '24px',
            width: '100%',
            justifyContent: 'center',
          }}
        >
          {containers.slice(3, 6).map((item, index) => (
            <div
              key={index + 3}
              style={{
                background: '#fff',
                borderRadius: 10,
                boxShadow: '0 1px 6px rgba(0,0,0,0.08)',
                padding: isMobile ? '16px 12px' : '28px 24px',
                minWidth: isMobile ? '100%' : '280px',
                maxWidth: isMobile ? '100%' : '380px',
                flex: isMobile ? '1 1 100%' : '1 1 0',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                textAlign: 'center'
              }}
            >
              <img
                src={item.img}
                alt={item.alt}
                style={{
                  width: isMobile ? '120px' : '180px',
                  height: isMobile ? '120px' : '180px',
                  objectFit: 'contain',
                  marginBottom: '16px'
                }}
              />
              <div style={{
                fontWeight: 700,
                fontSize: isMobile ? '0.85rem' : '1.1rem',
                color: '#09225C',
                marginBottom: '10px',
                lineHeight: 1.3
              }}>
                {item.title[lang]}
              </div>
              <div style={{
                fontWeight: 400,
                fontSize: isMobile ? '0.7rem' : '0.85rem',
                color: '#444',
                lineHeight: 1.5,
                whiteSpace: 'pre-line'
              }}>
                {item.desc[lang]}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default ProductMOBFunction2;
